import { FormattedMessage } from 'react-intl';
import { Typography } from '@rossum/ui/material';
import styles from '../../style.module.sass';

const KeyboardShortcutsInfo = () => (
  <>
    <Typography variant="body2">
      <FormattedMessage id="components.documentValidation.validationSources.tooltip.shortcuts.title" />
    </Typography>
    <div className={styles['KeyboardShortcutsWrapper']}>
      <div className={styles['KeyboardShortcuts']}>
        <div>
          <span className={styles['KeyboardKey']}>TAB</span>
        </div>
        <div>
          <span className={styles['KeyboardKey']}>ENTER</span>
        </div>
      </div>
      <div className={styles['KeyboardShortcuts']}>
        <Typography variant="body2">
          <FormattedMessage id="components.documentValidation.validationSources.tooltip.tab" />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage id="components.documentValidation.validationSources.tooltip.enter" />
        </Typography>
      </div>
    </div>
  </>
);

export default KeyboardShortcutsInfo;
